<!-- 定向询价 enquiryType: 0 Enquiry/querySupplierOfferList-->
<template>
  <div>
    <div class="container">
      <Search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :btn-hidden="false"
        :count="100"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      ></Search>
    </div>

    <div class="container">
      <div v-if="query.offerOrNot === 1" class="handle-wrapper">
        <eui-btn @click="handleExport">导出报价单信息</eui-btn>
      </div>
      <TableList
        :loading="tableLoading"
        :table-data="tableData"
        :table-label="tableLabel"
        index-show
      >
        <template #createSource="{ scope }">
          <div>{{ createSourceTypeObj[scope.row.createSource] }}</div>
        </template>
        <template #purchaseCompany="{ scope }">
          <div class="purchaseCompany">{{ scope.row.purchaseCompany }}</div>
          <eui-btn type="link" font-size="12px" @click="openMessage(scope.row)">
            <div style="display: flex; align-items: center">
              <img :src="messageImg" />
              发送留言
            </div>
          </eui-btn>
        </template>
        <template #endTime="{ scope }">
          <div class="stop-time">
            <count-down
              v-if="scope.row.quotationDeadline"
              :stop-time="scope.row.quotationDeadline"
            ></count-down>
            <span v-else style="color: #e8efff">0天0小时0分0秒</span>
          </div>
        </template>
        <!-- 操作 quotationCount 供应商报价数量 -->
        <template #operation="{ scope }">
          <eui-btn
            v-if="
              (scope.row.enquiryStatus === 4 ||
                scope.row.enquiryStatus === 2) &&
              scope.row.quotationCount === 0
            "
            type="link"
            font-size="12px"
            @click="handleViewOffer(scope.row)"
          >
            报价
          </eui-btn>
        </template>
        <!-- 弹框 -->
      </TableList>
      <div class="pagination">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="listQuery.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="listQuery.pageSize"
          :total="total"
          @current-change="handleCurrentCange"
        ></el-pagination>
      </div>
    </div>
    <MessageBoard
      :visible="messageVisible"
      :set-visible="setVisible"
      :current="current"
      :content="content"
    />
    <!-- 延时弹窗 -->
    <!--
      
      title="报价有效期时间延时"
      :visible.sync="delayVisible"
      width="600px"
      :before-close="handleClose"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="set-price"
      -->
    <e-dialog
      dialog-title="报价有效期时间延时"
      dialog-type=""
      :center-dialog-visible="delayVisible"
      :popup-width="'450px'"
      :show-close="false"
      @submitPopupData="handleDelay"
      @updateVisible="delayVisible = false"
      @resetPopupData="delayVisible = false"
    >
      <div class="">
        <el-form
          ref="delayForm"
          :model="delayForm"
          :rules="delayRules"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="询价单名称：" prop="name">
            <span>{{ paramsRow.enquiryName }}</span>
          </el-form-item>
          <!-- :picker-options="quotationDeadlineTimeDate" -->
          <el-form-item label="报价有效期时间：" prop="quotationDeadline">
            <el-date-picker
              v-model="delayForm.quotationDeadline"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH"
              value-format="timestamp"
              default-time="16:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="延时原因：" prop="remark">
            <el-input
              v-model="delayForm.remark"
              type="textarea"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import TableList from '@/modules/projectA/components/common/e-table-list';
import Search from '@/modules/projectA/components/common/e-search';
import api from '@/modules/projectA/api/order';
import utils from '@/modules/projectA/utils/utils';
import MessageBoard from '@/modules/projectA/components/messageBoard';
import Api from '@/modules/projectA/api/enquiry';

import countDown from '../countDown';

console.log(Api, 'ApiApiApiApi');

const createSourceTypeObj = {
  0: '平台询价',
  1: '平台询价',
  2: '石化询价',
};
export default {
  components: {
    TableList,
    Search,
    MessageBoard,
    eDialog,
    countDown,
  },
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
    back: String,
  },
  data() {
    return {
      rateNum: 0,
      showOnlineFlag: true,
      tipContent: '', // 点对点 和 平台 被 拉黑的 提示
      confirmProtocol: false, // 是否确认协议
      confirmFlag: false,
      blackInfo: {},

      ecStr: '',
      createSourceTypeObj,
      messageImg: require('@/assets/img/messageBoard/message.svg'),
      messageVisible: false,
      current: {},
      btnLoading: false,
      delayVisible: false,
      delayForm: { remark: '', quotationDeadline: '' },
      delayRules: {
        /* quotationDeadline: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ] */
      },
      quotationDeadlineTimeDate: {
        disabledDate: (time) => {
          const beginTime = this.paramsRow.quotationValidity;
          console.log(beginTime, 'beginTime');
          if (beginTime) {
            return (
              time.getTime() <
                new Date(beginTime).getTime() +
                  1 *
                    ((24 - new Date(beginTime).getHours()) * 60 * 60 * 1000) ||
              time.getTime() >
                new Date(beginTime).getTime() + 15 * (24 * 60 * 60 * 1000)
            );
          }
        },
      },
      paramsRow: {},
      directionalLength: '',
      allLength: '',
      waitLength: '',
      publicFlag: false,

      // 有时间的不要给默认值了
      listQuery: {
        quotationDeadlineStart: null,
        quotationDeadlineEnd: null,
        purchaseCompany: null,
        enquiryName: null,
        enquiryNo: null,
        offerStatus: null,
        pageNum: 1,
        pageSize: 10,
        isDoC: null,
        shipmentType: null,
        createSource: null,
        createMemberName: null,
      },
      total: 0,
      cloneListQuery: {},

      fieldList: [
        { label: '询价企业', type: 'input', value: 'purchaseCompany' },
        { label: '询价单名称', type: 'input', value: 'enquiryName' },
        { label: '询价单编号', type: 'input', value: 'enquiryNo' },
        { label: '询价人', type: 'input', value: 'createMemberName' },
        {
          label: '结算方式',
          type: 'select',
          value: 'isDoC',
          list: 'isDoCOptions',
          clearable: true,
        },
        {
          label: '配送方式',
          type: 'select',
          value: 'shipmentType',
          list: 'shipmentTypeOptions',
          clearable: true,
        },
        /* {
          label: '询价来源',
          type: 'select',
          value: 'createSource',
          list: 'createSourceOptions',
          clearable: true,
        }, */
        {
          label: '报价截止时间',
          type: 'date',
          value: 'createTime',
          dateType: 'datetimerange',
          defaultTime: ['00:00:00', '23:59:59'],
          clearable: true,
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      listTypeInfo: {
        queryAfterSaleType: [
          { name: '全部', id: null },
          /* { name: '待报价', id: 0 }, */
          { name: '已报价', id: 1 },
          { name: '已入选', id: 2 },
          { name: '未入选', id: 3 },
          { name: '磋商中', id: 6 },
        ],
        isDoCOptions: [
          { name: '全部', id: null },
          { name: '款到发货', id: 0 },
          { name: '货到付款', id: 1 },
        ],
        shipmentTypeOptions: [
          { name: '全部', id: null },
          { name: '卖家自行配送', id: 1 },
          /* { name: '自提', id: 2 }, */
          { name: '第三方物流', id: 3 },
        ],
        createSourceOptions: [
          { name: '全部', id: null },
          { name: '平台询价', id: 0 },
          { name: '石化询价', id: 1 },
        ],
      },

      tableData: [],
      // queryEnquiryPage
      tableLabel: [
        {
          label: '询价单名称',
          param: 'enquiryName',
          align: 'center',
          minWidth: '180',
        },
        {
          label: '询价单编号',
          param: 'enquiryNo',
          align: 'center',
          minWidth: '160',
        },
        {
          label: '询价企业',
          slot: 'purchaseCompany',
          align: 'center',
          minWidth: '280',
        },
        {
          label: '询价来源',
          slot: 'createSource',
          align: 'center',
          minWidth: '120',
        },
        {
          label: '结算方式',
          param: 'isDoC',
          align: 'center',
          render: (row) => {
            const obj = {
              0: '款到发货',
              1: '货到付款',
            };

            return obj[row.isDoC];
          },
        },
        {
          label: '配送方式',
          align: 'center',
          render: (row) => {
            const obj = {
              1: '卖家自行配送',
              3: '第三方物流',
            };

            return obj[row.shipmentType];
          },
          minWidth: '120',
        },
        {
          label: '询价人',
          param: 'realName',
          align: 'center',
        },
        {
          label: '报价开始时间',
          param: 'releaseTime',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '报价截止时间',
          param: 'quotationDeadline',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '距结束',
          param: 'quotationDeadline',
          align: 'center',
          minWidth: '150',
          slot: 'endTime',
        },
        {
          label: '操作',
          width: '200',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      content: '',
      tableLoading: false,
    };
  },
  computed: {
    cancellationTitle() {
      // directional 定向
      return this.tabEnquiryType === 'directional'
        ? '您的操作将作废报价单据，这条单据下所有报价信息均将认作失效，此操作无法恢复，是否继续？'
        : '您的操作将作废报价单据，这条单据下所有报价信息均将认作失效，此操作无法恢复，是否继续？';
    },
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    // 处理 查询 和 列表不同
    const { offerOrNot = -1 } = this.query;
    // 定向公开列表与搜索一样 不需要处理
    // 已报价的 搜索多询价状态 列表多报价状态少报价时间
    if (offerOrNot === 1) {
      this.tableLabel.splice(this.tableLabel.length - 2, 1);
      this.tableLabel.splice(2, 0, {
        label: '询价单状态',
        param: 'offerStatus',
        align: 'center',
        render: (row) => {
          const obj = {
            1: '已报价',
            2: '已入选',
            3: '未入选',
            4: '询价过期',
            5: '询价作废',
            6: '磋商中',
          };

          return obj[row.offerStatus];
        },
      });
      if (this.$store.state.USERINFO.identity !== 'purchase') {
        const arr = [
          { name: '询价作废', id: 5 },
          { name: '询价过期', id: 4 },
        ];
        this.listTypeInfo.queryAfterSaleType =
          this.listTypeInfo.queryAfterSaleType.concat(arr);
      }
      this.fieldList.splice(4, 0, {
        label: '报价状态',
        type: 'select',
        value: 'offerStatus',
        list: 'queryAfterSaleType',
        clearable: true,
        itemHidden: false,
      });
    }
    this.getList(this.listQuery);
  },
  methods: {
    handleDelete(row) {
      // removeOffer
      this.$confirm('您正在执行删除操作，删除后无法恢复，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          Api.removeOffer({ supplierOfferId: row.supplierOfferId }).then(
            (result) => {
              if (result.code === '200') {
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
                this.getList(this.listQuery);
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 导出
    handleExport: _.debounce(async function () {
      const result = await api.exportOfferInfo({
        ...this.listQuery,
        createSource: null,
      });
      if (result?.code === '500') {
        return;
      }
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        const time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(result, `报价单信息${time}`);
      }
    }),
    setVisible(bool) {
      this.messageVisible = bool;
    },
    openMessage(row) {
      const { purchaseCompany, purchaseCompanyId } = row;
      this.content = `询价单名称：${row.enquiryName};询价单编号:${row.enquiryNo};`;
      this.current = {
        ...row,
        replyCompanyName: purchaseCompany,
        replyCompanyId: purchaseCompanyId,
      };
      this.messageVisible = true;
    },
    // 作废 弹窗操作
    async handleCancellation(row) {
      this.$confirm(this.cancellationTitle, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await api
            .cancelSupplierOffer({ supplierOfferId: row.supplierOfferId })
            .then((res) => {
              if (res.code === '200') {
                this.getList(this.listQuery);
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openDelayDia(row) {
      this.delayVisible = true;
      this.paramsRow = { ...row };
    },

    // 延时操作
    handleDelay() {
      this.$refs.delayForm.validate(async (valid) => {
        if (valid) {
          const params = {
            remark: this.delayForm.remark,
            supplierOfferId: this.paramsRow.supplierOfferId,
            newSupplierOfferChangeDataAO: {
              quotationValidity: this.delayForm.quotationDeadline,
            },
          };
          const result = await api.changeSupplierOfferDelay(params);
          if (result.code === '200') {
            this.getList(this.listQuery);
            this.delayVisible = false;
          }
        } else {
          return false;
        }
      });
    },

    // 查看详情
    async handleViewDetails(row) {
      if (row.createSource && row.createSource !== 0) {
        this.ecStr = '查看详情';
        this.current = row;
      } else {
        this.$router.push({
          path: '/emergencySeeDetails',
          query: { type: 'viewDetails', ...row, back: this.back },
        });
      }
    },

    async handleViewOffer(row = {}) {
      const { createMode } = row;
      if (createMode === 6) {
        // 应急的单子只校验是否是应急供应商其他的不做任何校验
        const res = await Api.checkWhetherEnquirySupplier();
        if (res.code === '200') {
          if (res.data) {
            this.$router.push({
              path: '/emergencySeeDetails',
              query: { type: 'offer', ...row, back: this.back },
            });
          } else {
            this.$message.warning(
              '您不是易派客应急物资供应商，无法参与此类报价。'
            );
          }
        }
      }
    },

    // 时间比较
    compareDate(d1) {
      const date1 = new Date(Date.parse(d1));
      const now = new Date();
      // 当前时间小于报价开始时间
      return date1 > now;
    },

    // 触发搜索按钮
    handleSearch(val) {
      if (val.createTime) {
        val.quotationDeadlineStart = val.createTime[0];
        val.quotationDeadlineEnd = val.createTime[1];
      } else {
        val.quotationDeadlineStart = null;
        val.quotationDeadlineEnd = null;
      }
      val.createSourceList = !Number.isInteger(val.createSource)
        ? null
        : val?.createSource === 0
        ? [0, 1]
        : [2];
      console.log(val, '搜索参数');
      this.listQuery = { ...val };
      this.getList(this.listQuery);
    },

    // 触发重置
    handleClear(val) {
      console.log(val, '重置参数');
      this.listQuery = { ...this.cloneListQuery };
      // this.listQuery = { ...val };
      this.getList(this.listQuery);
    },

    handleCurrentCange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    async getList(params) {
      try {
        Object.assign(params, this.query);
        this.tableLoading = true;
        const result = await Api.queryEmergencyEnquiryPage(params);
        if (result.code === '200') {
          this.tableData = result.data.records;
          this.total = result.data.total;
        }
      } finally {
        this.tableLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* .purchaseCompany {
  margin: 20px 0 14px 0;
} */

.message {
  display: flex;
  align-items: center;
  color: rgb(0, 100, 200);
  cursor: pointer;
  justify-content: center;
  margin-bottom: 10px;

  img {
    width: 18px;
    margin-right: 6px;
  }
}

::v-deep .el-textarea__inner {
  border-radius: 0;
}

.stop-time {
  color: #f0250f;
}
</style>
